import React, { useState } from 'react';
import { FaMailBulk, FaLock, FaSignInAlt } from 'react-icons/fa';
import { UserModel } from '../../../models/UserModel';
import { loginAsUser } from '../../../services/User_service';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

interface ConnectionInfoTabProps {
  localUser: UserModel;
}

const ConnectionInfoTab: React.FC<ConnectionInfoTabProps> = ({ localUser }) => {
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLoginAsUser = async () => {
    const result = await Swal.fire({
      target: document.body, // sort du container scrollable
      title: 'Confirmation',
      html: `
        <p>Voulez-vous vous connecter en tant que :</p>
        <p><strong>${localUser.firstname} ${localUser.name}</strong></p>
        <p><small>Email: ${localUser.email}</small></p>
        <br/>
        <p style="color:#dc3545"><small>⚠️ Vous serez déconnecté de votre session admin</small></p>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2A919D',
      cancelButtonColor: '#dc3545',
      confirmButtonText: 'Oui, se connecter',
      cancelButtonText: 'Annuler',
      allowOutsideClick: false,
      backdrop: true,
      customClass: {
        popup: 'swal-on-top'
      }
    });

    if (!result.isConfirmed) return;

    setIsLoggingIn(true);

    try {
      await loginAsUser(localUser.id);

      toast.success(`Connecté en tant que ${localUser.firstname} ${localUser.name}`);

      setTimeout(() => {
        navigate('/home');
        window.location.reload();
      }, 500);

    } catch (error: any) {
      console.error('Erreur login:', error);
      Swal.fire({
        target: document.body,
        icon: 'error',
        title: 'Erreur',
        text: error?.message || 'Impossible de se connecter',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-hover">
        <tbody>
          <tr>
            <th><FaMailBulk className="me-2" />Email</th>
            <td>{localUser.email || "Aucune information"}</td>
          </tr>
          <tr>
            <th><FaLock className="me-2" />Mot de passe</th>
            <td>{localUser.plain_password || "Aucune information"}</td>
          </tr>
        </tbody>
      </table>

      <div className="d-flex flex-column align-items-center mt-3 text-center">

  <button
    className="btn btn-primary-custom d-flex align-items-center gap-2 px-4 py-3 mb-3"
    onClick={handleLoginAsUser}
    disabled={isLoggingIn}
  >
    <FaSignInAlt />
    {isLoggingIn
      ? "Connexion en cours..."
      : `Se connecter en tant que ${localUser.firstname} ${localUser.name}`}
  </button>

  <div className="alert alert-info w-100" style={{ maxWidth: "520px" }}>
    <i className="bi bi-info-circle-fill me-2"></i>
    <strong>Information :</strong> Vous serez connecté en tant que login test
    et votre session admin sera fermée.
  </div>

</div>


    </div>
  );
};

export default ConnectionInfoTab;
